__webpack_require__.p = "/board/";